import React, { useRef, useState } from 'react';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Money, Input, Label, Row, Button, Textarea, LinkToggle, Phone } from '../../components/FormComponent';

import Modal from '../../components/Modal';

import AfterPayment from './AfterPayment';
import Reminder from './Reminder';

function CreateLink() {
    const formRef = useRef(null);

    const [modalMessage, toggleModalMessage] = useState(0);
    const [modalReminder, toggleModalReminder] = useState(0);
    
    async function handleSubmit(data) {
        try {
            const schema = Yup.object().shape({
                money: Yup.string().required('Você deve escolher um valor'),
                description: Yup.string().required('Não pode ficar em branco'),
                message: Yup.string().min(10, 'No mínimo 10 caracteres')
                .required('Não pode ficar em branco'), 
            });

            await schema.validate(data, {
                abortEarly: false
            });

            // Validação passou
            console.log(data);
        }
        catch (err) {
            const validationErrors = {};
            
            if (err instanceof Yup.ValidationError) {
                err.inner.forEach(error => {
                    validationErrors[error.path] = error.message;
                });
                
                formRef.current.setErrors(validationErrors);
            }
        }
    }

    return(
        <div className="CreateLink">
            <Form ref={formRef} onSubmit={ handleSubmit }>
                <Row>
                    <Label title="Valor" to="money" />
                    <Money name="money" placeholder="0,00" currency="R$" />
                </Row>

                <Row>
                    <Label title="Descrição" to="description" />
                    <Input name="description" placeholder="Exemplo: pagamento do churrasco" />
                </Row>

                <Row>
                    <Label title="Número do celular do destinatário" to="phone" />
                    <Phone name="phone" placeholder="099 99999-9999" />
                </Row>

                <Row>
                    <Label title="Mensagem" to="message" />
                    <Textarea name="message" rows="4" placeholder="Exemplo: Gente, segue o link para o pagamento do churrasco aqui de casa" />
                </Row>

                <Row>
                    <Label title="Após o pagamento" />
                    <LinkToggle title="Mensagem Padrão" onClick={ e => toggleModalMessage(1) } />
                </Row>

                <Row>
                    <Label title="Enviar lembrete" />
                    <LinkToggle title="Após 7 dias" onClick={ e => toggleModalReminder(1) } />
                </Row>

                <Row classRow="form__row--button">
                    <Button type="submit" value="Enviar SMS" btnClass="btn--secondary btn--lg btn--block" />
                </Row>
            </Form>

            <Modal modalState={modalMessage} toggleModal={ toggleModalMessage }>
                <AfterPayment />
            </Modal>

            <Modal modalState={modalReminder} toggleModal={ toggleModalReminder }>
                <Reminder />
            </Modal>
        </div>
    )
}

export default CreateLink;